import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const DEFAULT_LANG = 'ptBR';

const locales = {
  ptBR: require('./i18n/ptBR.json'),
  en: require('./i18n/en.json'),
};


export const i18n: any = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
});

// Vue.use(Vuetify, {
//   lang: {
//     t: (key, ...params) => i18n.t(key, params)
//   }
// })

export default i18n;
